import type { LocaleResources } from '../types';

/**
 * User-friendly English message mapping for ccxt error names
 */
export const CcxtErrorMessages: LocaleResources['CcxtErrorMessages'] = {
  // Authentication related
  AuthenticationError: 'API key authentication failed. Please check your API key settings.',
  PermissionDenied: 'API key permissions are insufficient. Please check API permissions on the exchange.',
  AccountNotEnabled: 'Account is not activated. Please check your account status on the exchange.',
  AccountSuspended: 'Account has been suspended. Please contact the exchange.',

  // Order related
  InvalidOrder: 'Order information is invalid.',
  OrderNotFound: 'Order not found.',
  DuplicateOrderId: 'Duplicate order ID.',
  InsufficientFunds: 'Insufficient balance.',
  OrderImmediatelyFillable: 'Order can be filled immediately. Please check order conditions.',
  OrderNotFillable: 'Order cannot be filled.',

  // Request related
  BadRequest: 'Invalid request.',
  BadSymbol: 'Invalid symbol.',
  BadResponse: 'Received invalid response from exchange.',
  ArgumentsRequired: 'Required input is missing.',

  // Network related
  NetworkError: 'Network error occurred. Please check your internet connection.',
  RequestTimeout: 'Request timed out. Please try again later.',
  ExchangeNotAvailable: 'Cannot connect to exchange server.',
  OnMaintenance: 'Exchange is under maintenance. Please try again later.',

  // Rate limiting related
  RateLimitExceeded: 'API request limit exceeded. Please try again later.',
  DDoSProtection: 'Request blocked due to DDoS protection. Please try again later.',
  InvalidNonce: 'System time does not match server time. Please check your system time.',

  // Others
  ExchangeError: 'Exchange error occurred.',
  NotSupported: 'Feature is not supported.',
  ContractUnavailable: 'Contract is unavailable.',
  InvalidAddress: 'Invalid address.',
};

/**
 * Returns user-friendly message for ccxt error name
 */
export function getCcxtErrorMessage(errorName: string): string | undefined {
  return CcxtErrorMessages[errorName];
}
